import React from "react";
import { ProfContainer, ProfH1, ProfWrapper, ProfCard, ProfIcon, ProfH2, ProfP } from "./ProfStyled";
import Icon7 from "../../img/Icon7.jpg"
import Icon6 from "../../img/Icon6.jpg"
import ScrollArrow from '../Botaozinho/index'

const Profissional = () => {
    return (
        <ProfContainer id='experiencia'>
            <ProfH1>Experiencia no mercado de trabalho</ProfH1>
            <ProfWrapper>
                <ProfCard>
                    <ProfIcon src={Icon6} />
                    <ProfH2>Valec</ProfH2>
                    <ProfP>Estagiei de uma forma bem completa na questão empresarial, hierarquia, sociabilização no trabalho, entre outros pontos que tirando a programação são muito importantes</ProfP>
                </ProfCard>
                <ProfCard>
                    <ProfIcon src={Icon7} />
                    <ProfH2> DeltaPoint</ProfH2>
                    <ProfP>Atuei 1 ano como Trainee/Jr utilizando React em um projeto que está online e em funcionamento. Durante todo meu tempo de trabalho atuei apenas no FrontEnd, porém estudando bastante todas as ramificações do Front, Back, B.I, Scrum.</ProfP>
                </ProfCard>
            </ProfWrapper>
            <ScrollArrow/>
        </ProfContainer>

    )
}

export default Profissional;